import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { UserPapStatus } from 'types';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

export const userPapStatusOptions = [
	{ value: UserPapStatus.NEW_PAP, label: 'New PAP' },
	{ value: UserPapStatus.NO_PAP, label: 'No PAP' },
	{ value: UserPapStatus.OLD_PAP, label: 'Old PAP' },
	{ value: UserPapStatus.PAP, label: 'PAP' },
];

const DriveUserPapStatusFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const papStatus = JSON.parse(searchParams.get('papStatus') || '[]');

	const options = userPapStatusOptions;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!papStatus?.length}
					placeholder={'PAP Status'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: papStatus?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (papStatus?.includes(option?.value?.toString())) {
											searchParams.set(
												'papStatus',
												JSON.stringify(papStatus?.filter((status: string) => status !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('papStatus', JSON.stringify([...papStatus, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{papStatus?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">PAP Status</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="New PAP"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => papStatus?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('papStatus', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default DriveUserPapStatusFilterInput;
